import { createAction } from "@reduxjs/toolkit";

export const getMyProfileAction = createAction("auth/my_profile");
